module.exports = __webpack_public_path__ + "img/btn-chatbot.95d40341.png";